import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FeatureService } from '@upassignations/feature';
import {
  AndromedaMenuComponent,
  AndromedaMenuOptionComponent,
  AuthService,
  NavigationPath,
  UpAssignationsUris,
} from '@upassignations/core';
import { UserMenuOption } from '../../models/user-menu-option';
import { UserMenuOptions } from '../../models/user-menu-options';
// import { AndromedaCustomTooltipDirective } from '@upassignations/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'lib-header',
  imports: [
    CommonModule,
    AndromedaMenuOptionComponent,
    AndromedaMenuComponent,
    // AndromedaCustomTooltipDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @ViewChild('menu') menu: AndromedaMenuComponent;

  userProfile: any;
  activeRoute = '';
  unauthorizedFeatures = [];
  featuresLoaded = false;

  menuOptions: UserMenuOptions[] = [{ label: UserMenuOption.Logout }];

  UserMenuOption = UserMenuOption;

  NavigationPath = NavigationPath;

  private isDownloadingSubject = new BehaviorSubject<boolean>(false);
  isDownloading$ = this.isDownloadingSubject.asObservable();
  isDownloadComplete$ = new BehaviorSubject<boolean>(false);

  constructor(
    // eslint-disable-next-line no-unused-vars
    private router: Router,
    // eslint-disable-next-line no-unused-vars
    private featureService: FeatureService,
    // eslint-disable-next-line no-unused-vars
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.initialiseUserProfile();
    this.subscribeToActiveRoute();
    this.getListOfUnauthorizedFeatures();
  }

  initialiseUserProfile(): any {
    this.authService.isLogged().subscribe((loggedIn) => {
      if (loggedIn) {
        this.featureService.getUserProfile$().subscribe((user) => {
          this.userProfile = user;
        });
      }
    });
  }
  getListOfUnauthorizedFeatures(): void {
    this.authService.isLogged().subscribe((loggedIn) => {
      if (loggedIn) {
        this.featureService
          .getListOfUnauthorizedFeatures$(
            UpAssignationsUris.UP_ASSIGNATIONS_V2,
            false
          )
          .subscribe((unauthorisedFeature: any[]) => {
            this.unauthorizedFeatures = unauthorisedFeature;
            this.featuresLoaded = true;
          });
      }
    });
  }
  trackingTableIsEnabled(): boolean {
    return (
      this.featuresLoaded &&
      !this.unauthorizedFeatures.some(
        (feature) => feature.service === 'amo:Feature_LitigationsDashboard'
      )
    );
  }

  archivesIsEnabled(): boolean {
    return (
      this.featuresLoaded &&
      !this.unauthorizedFeatures.some(
        (feature) => feature.service === 'amo:Feature_LitigationsHistory'
      )
    );
  }

  logsTableIsEnabled(): boolean {
    return (
      this.featuresLoaded &&
      !this.unauthorizedFeatures.some(
        (feature) => feature.service === 'amo:Feature_Logs'
      )
    );
  }

  notificationsCenterIsEnabled(): boolean {
    return (
      this.featuresLoaded &&
      !this.unauthorizedFeatures.some(
        (feature) => feature.service === 'amo:Feature_Notifications'
      )
    );
  }
  subscribeToActiveRoute(): void {
    this.router.events.subscribe(() => {
      this.activeRoute = this.router.url;
    });
  }

  redirectToUploadSpace(): any {
    this.router.navigate([NavigationPath.UploadSpace]);
  }

  redirectToUploadsHistory(): any {
    this.router.navigate([NavigationPath.UploadsHistory]);
  }

  redirectToTrackingTable(): any {
    this.router.navigate([NavigationPath.TrackingTable]);
  }

  redirectToArchives(): any {
    this.router.navigate([NavigationPath.Archives]);
  }

  redirectToLogsTable(): any {
    this.router.navigate([NavigationPath.LogsTable]);
  }

  redirectToNotificationsCenter(): any {
    this.router.navigate([NavigationPath.NotificationsCenter]);
  }

  redirectToLogout(): any {
    this.router.navigate([NavigationPath.Logout]);
  }

  onClickOnOption(option: UserMenuOptions, event?): void {
    this.menu.optionHasBeenClicked(event);

    switch (option.label) {
      case UserMenuOption.Logout:
        this.redirectToLogout();
        break;

      default:
        break;
    }
    event?.stopPropagation();
  }

  downloadUserGuide(): void {
    this.isDownloadingSubject.next(true);
    this.isDownloadComplete$.next(false);
    this.featureService.downloadUserGuide$().subscribe({
      next: (response) => {
        if (!response.error) {
          this.downloadGeneratedFile(response.fileName);
        }
      },
      error: () => {
        this.isDownloadingSubject.next(false);
        this.isDownloadComplete$.next(false);
      },
      complete: () => {
        this.isDownloadingSubject.next(false);
        this.isDownloadComplete$.next(true);

        setTimeout(() => {
          this.isDownloadComplete$.next(false);
        }, 1000);
      },
    });
  }
  downloadGeneratedFile(fileName: string): void {
    if (fileName) {
      this.featureService
        .downloadExportedFileFromServer(fileName)
        .subscribe((response) => {
          this.convertFileStreamToLocalFile(response, fileName);
        });
    }
  }
  convertFileStreamToLocalFile(fileStream: BlobPart, fileName: string): void {
    const blob = new Blob([fileStream], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
